// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WorkstationIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 56 39">
    <path
      fill="url(#workstation_svga)"
      d="M47.47 30.57c0 .8-.62 1.41-1.42 1.41H34.2a2.8 2.8 0 0 1-2.6 1.64h-7.12a2.9 2.9 0 0 1-2.6-1.64H10a1.4 1.4 0 0 1-1.41-1.4c0-.8.62-1.42 1.41-1.42h13c.79 0 1.41.62 1.41 1.41v.23h7.18v-.23c0-.79.62-1.41 1.41-1.41h13.05c.74 0 1.42.68 1.42 1.41m3.16 8.08H5.43c-3 0-5.43-2.43-5.43-5.42v-2.66c0-.8.62-1.41 1.41-1.41h2.66V3.67A3.67 3.67 0 0 1 7.74 0h40.4a3.8 3.8 0 0 1 3.8 3.56v25.6h2.65c.79 0 1.4.62 1.4 1.41v2.66c.07 3-2.36 5.42-5.36 5.42m-45.2-2.82h45.2c1.41 0 2.6-1.2 2.6-2.6v-1.25h-2.66a1.4 1.4 0 0 1-1.4-1.41V3.79c-.06-.51-.52-.96-.97-.96H7.74c-.45 0-.85.4-.85.84v26.9c0 .8-.62 1.41-1.4 1.41H2.82v1.25a2.6 2.6 0 0 0 2.6 2.6M34.06 23.5a1.4 1.4 0 0 0 1.98.17l7-5.94a1.4 1.4 0 0 0 0-2.14l-7-6a1.37 1.37 0 0 0-1.98.18c-.5.62-.45 1.46.17 1.97l5.77 4.86-5.77 4.86c-.62.51-.67 1.42-.17 2.04M20 23.68a1.4 1.4 0 0 0 1.98-.17c.51-.62.45-1.47-.17-1.98l-5.7-4.86 5.7-4.92c.62-.5.68-1.4.17-1.97A1.37 1.37 0 0 0 20 9.6l-7 5.93a1.4 1.4 0 0 0 0 2.15zm4.52 1.7q.26.09.51.1a1.4 1.4 0 0 0 1.3-.9l5.94-14.86a1.4 1.4 0 0 0-.8-1.8 1.4 1.4 0 0 0-1.8.78l-5.94 14.86a1.4 1.4 0 0 0 .8 1.81"
    />
    <defs>
      <linearGradient
        id="workstation_svga"
        x1={0}
        x2={37.71}
        y1={0}
        y2={51.93}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6E45E2" />
        <stop offset={1} stopColor="#A22E95" />
      </linearGradient>
    </defs>
  </svg>,
  "Workstation",
);
export default WorkstationIcon;
